import { jsx as _jsx } from "react/jsx-runtime";
import { ChainType } from '@lifi/sdk';
import { SuiClientContext } from '@mysten/dapp-kit';
import { useContext } from 'react';
import { useInternalWalletProvider } from '../../hooks/useInternalWalletProvider.js';
import { isItemAllowed } from '../../utils/item.js';
import { useWidgetConfig } from '../WidgetProvider/WidgetProvider.js';
import { SuiBaseProvider } from './SuiBaseProvider.js';
import { SuiExternalContext } from './SuiExternalContext.js';
function useInSuiContext() {
    const { chains } = useWidgetConfig();
    const context = useContext(SuiClientContext);
    return Boolean(context) && isItemAllowed(ChainType.MVM, chains?.types);
}
export const SuiProvider = ({ children }) => {
    const inSuiContext = useInSuiContext();
    const useInternalWallet = useInternalWalletProvider(inSuiContext);
    return useInternalWallet ? (_jsx(SuiBaseProvider, { children: children })) : (_jsx(SuiExternalContext.Provider, { value: inSuiContext, children: children }));
};
//# sourceMappingURL=SuiProvider.js.map